import ApiClient from 'redbay-b2b-api/src/ApiClient'
import Storage from "./BrandStorage";


export default {
  namespaced: true,

  state: {
    list: [],
    selected: [],
    filters: []
  },

  mutations: {

    list(state, response) {
      state.list = response.data;
    }
  },


  actions: {
    saveStorage({state}) {
      Storage.saveParams(state.selected);
    },

    selected({commit, state}, brand) {
      state.selected = brand.brand;
      if(brand.top){
        this.dispatch('search/selectedProducerClear', [brand.brand.id])
      } else {
        this.dispatch('search/selectedProducer', [brand.brand.id])
      }
    },

    setFilters({commit, state}, filters) {
      state.filters = filters;
    },

    async requestData({commit, state}) {
      let result = await ApiClient.get('shop/brands');
      commit('list', result);
    }
  },
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/redbay-b2b-brands/src/BrandStore.js
// module id = null
// module chunks = 